import { Button, Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '../../../../components/Accordion';
import BooleanCheckbox from '../../../../components/fields/BooleanCheckbox';
import OutlinedInputField from '../../../../components/fields/OutlinedInputField';
import DealerSelection from './DealerSelection';
import SelectedDealersList from './SelectedDealersList';
import TagSelection from './TagSelection';
import useInviteQuoteData from './hooks/useInviteQuoteData';
import useInviteQuoteSelection from './hooks/useInviteQuoteSelection';
import { useSingleButtonStyles } from './shared';

const CreationForm = () => {
    const { t } = useTranslation('purchaseTransactionsPage');
    const styles = useSingleButtonStyles({ desktopJustifyContent: 'flex-end' });
    const { dealers, tags } = useInviteQuoteData();
    const { availableDealers, onDealerSelectionChange, onTagSelectionChange, selectedDealers } =
        useInviteQuoteSelection({
            dealers,
            ignoreInSessionFilter: false,
            inSessionDealerIds: [],
            tags,
        });

    return (
        <Accordion title={t('purchaseTransactionsPage:accordionTitle.createQuotation')} defaultExpanded>
            <Grid spacing={2} container>
                <Grid lg={12} item>
                    <BooleanCheckbox
                        color="secondary"
                        label={t('quotation.mainInfo.hideVehicleNo')}
                        name="hideVehicleNo"
                        style={{ color: 'red' }}
                    />
                </Grid>
                <Grid xs={12} item>
                    <OutlinedInputField
                        color="secondary"
                        label={t('quotation.mainInfo.remarks')}
                        name="remarks"
                        placeholder={t('quotation.mainInfo.enterDescription')}
                        multiline
                    />
                </Grid>
                <Grid lg={6} md={6} sm={12} xs={12} item>
                    <TagSelection onSelectionChange={onTagSelectionChange} tags={tags} />
                </Grid>
                <Grid lg={6} md={6} sm={12} xs={12} item>
                    <DealerSelection dealers={availableDealers} onSelectionChange={onDealerSelectionChange} />
                </Grid>
                <Grid xs={12} item>
                    <SelectedDealersList selectedDealers={selectedDealers} displayDealerTagNames />
                </Grid>
                <Grid className={styles.actionButtonContainer} style={{ marginTop: '0px' }} xs={12} item>
                    <Grid md={6} xs={12} item>
                        <Button className={styles.actionButton} color="secondary" type="submit" variant="contained">
                            {t(`purchaseTransactionsPage:quotation.sendForQuotation`)}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Accordion>
    );
};

export default CreationForm;
